/*
 * @Author: Yun
 * @Date: 2023-11-29 10:26:01
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-29 17:02:25
 */
import React, { useState, useEffect } from 'react'
import setWxShare from '@utils/wxShare'
import PcPage from '@views/pc'
import MobilePage from '@views/mobile'
import $ from 'jquery'
import './index.less'

const PREFIX = 'china23'

const China23 = (props) => {
    const [isPc, setIsPc] = useState(true)

    useEffect(() => {
        console.log(
            '%cYun',
            'font-family: "Poppin-Bold"; color:#fff; font-size:24px; font-weight:bold; text-shadow: #b19f4f 1px 0 10px; padding: 0 10px;'
        )
        setIsPc(handlePC)

        $(window)
            .on('resize', function () {
                resize()
            })
            .trigger('resize')

        if (isWeiXin()) {
            setWxShare({
                title: "Chinese Modernization, People's Well-being Matters Most",
                desc: "'Chinese Modernization, People's Well-being Matters Most,' a special interactive page has been launched by CGTN. Click the link below to obtain more details on China's modernization drive and high-quality development in various areas in 2024 through visual effects and in-depth stories.",
                site_link: 'https://news.cgtn.com/event/2024/China2024/index.html',
                img_url: 'https://news.cgtn.com/event/2024/China2024/poster.jpg',
                success: () => {
                    console.log('Share success!')
                },
                cancel: () => {
                    console.log('Share cancel!')
                },
            })
        }
    }, [])

    // wxShare
    function isWeiXin() {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true
        } else {
            return false
        }
    }

    // 判断是否为PC
    const handlePC = () => {
        let userAgentInfo = navigator.userAgent
        let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
        let flag = true
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false
                break
            }
        }
        return flag
    }

    const getScrollWidth = () => {
        let noScroll,
            scroll,
            oDiv = document.createElement('DIV')
        oDiv.style.cssText =
            'position:absolute; top:-9999px; width:100px; height:100px; overflow:hidden;'
        noScroll = document.body.appendChild(oDiv).clientWidth
        oDiv.style.overflowY = 'scroll'
        scroll = oDiv.clientWidth
        document.body.removeChild(oDiv)
        return noScroll - scroll
    }

    const resize = () => {
        //set rem basic value
        let window_width = window.innerWidth - getScrollWidth()
        let rule_num = (window_width * 20) / 480
        let pc_num = (window_width * 100) / 1920
        if (isPc) {
            $('html').css('font-size', pc_num + 'px')
        } else {
            $('html').css('font-size', rule_num + 'px')
        }
    }

    return <div className={PREFIX}>{isPc ? <PcPage /> : <MobilePage />}</div>
}

export default China23
